/* eslint-disable react/jsx-pascal-case */
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import io, { Socket } from "socket.io-client";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import { amountFormat } from "../../../Component/tool/Tools";
import icon_down_black from "../../../Image/ic_down_black.png";
import icon_question_circle_gray from "../../../Image/ic_question_circle_gray.png";
import ChatComponent from "../../Chat/ChatComponent";
import AdminLive from "./AdminLive";
import { live_info_type } from "../../User/Live/Live";

interface BuyBtnProps {
  $count: number;
}
interface Live_Start_Props {
  $state: string;
  $select_cam: string;
  $select_mic: string;
}
interface ChatComponentRef {
  sendMessage: () => void;
}

type props_data_type = {
  seq: number;
  live_seq: number;
  name: string;
  price: number;
  option_check: string;
  init_cnt: number;
  current_cnt: number;
  product_status: string;
  product_num: number | null;
  unique_option1: string[];
  unique_option2: string[];
};

const Live_Manage = () => {
  const Navigate = useNavigate();
  const { seq } = useParams();

  const [data, set_Data] = useState<props_data_type | null>();
  const [live_info, set_Live_Info] = useState<live_info_type>();
  const [live_time, set_Live_Time] = useState<string>("00:00:00");
  const [viewer_count, set_Viewer_Count] = useState<number>(0);
  const [mesage, set_Mesage] = useState<string>("");

  const [livestart, setLivestart] = useState("end");
  const [live_start, setLive_start] = useState("");
  const [live_finish, setLive_finish] = useState("");
  const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([]);
  const [audioDevices, setAudioDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<string>("");
  const [selectedAudio, setSelectedAudio] = useState<string>("");

  const go_back = () => Navigate("/admin/livelist");
  useEffect(() => {
    // Amazon IVS SDK 동적 로드
    const script = document.createElement("script");
    script.src =
      "https://web-broadcast.live-video.net/1.16.0/amazon-ivs-web-broadcast.js";
    script.async = true;
    document.body.appendChild(script);
    script.onload = async () => {
      // SDK 로드 후 권한 확인
      console.log("SDK로드");
      await checkPermissions();
    };
    return () => {
      document.body.removeChild(script); // cleanup
    };
  }, []);

  const checkPermissions = async () => {
    try {
      const cameraPermission = await navigator.permissions.query({
        name: "camera" as PermissionName,
      });
      const microphonePermission = await navigator.permissions.query({
        name: "microphone" as PermissionName,
      });

      if (
        cameraPermission.state === "granted" &&
        microphonePermission.state === "granted"
      ) {
        // 권한이 이미 허용되어 있으면 장치 목록을 초기화합니다.
        await initializeDeviceSelect();
      } else {
        // 권한이 허용되어 있지 않으면 requestPermissions 호출
        requestPermissions();
      }
    } catch (err) {
      // console.error("권한 확인 중 오류가 발생했습니다.", err);
    }
  };

  const initializeDeviceSelect = async () => {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoDevices = devices.filter((d) => d.kind === "videoinput");
    const audioDevices = devices.filter((d) => d.kind === "audioinput");

    setVideoDevices(videoDevices);
    setAudioDevices(audioDevices);
  };

  const requestPermissions = async () => {
    try {
      // 사용자의 카메라 및 마이크 권한 요청
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      // 권한이 허용되면 장치 목록을 가져옵니다.
      await initializeDeviceSelect();

      // 권한 요청 후 스트림을 정리합니다.
      stream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      console.error("카메라 또는 마이크 권한이 거부되었습니다.", err);
      alert(
        "카메라와 마이크 권한이 필요합니다. \n장치 연결 후 브라우저 설정에서 권한을 허용해 주세요."
      );
    }
  };

  const get_live_info = () => {
    axios
      .get(url.Communication_url.get_live_info, {
        params: {
          seq: seq,
        },
      })
      .then(function (response) {
        set_Live_Info(response.data);
        setLive_start(response.data.live_start || "");
        setLive_finish(response.data.live_finish || "");
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };

  useEffect(() => {
    // 우클릭 금지
    const originalOnContextMenu = document.oncontextmenu;
    document.oncontextmenu = function () {
      return false;
    };
    seq !== "undefined" && get_live_info();

    return () => {
      document.oncontextmenu = originalOnContextMenu;
    };
  }, []);

  const Live_Start = () => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (selectedVideo === "" || selectedAudio === "") {
      alert("비디오 장치와 오디오 장치를 선택해주세요");
    } else if (
      moment(live_start).format("YYYY_MM_DD HH:mm:ss") >
        moment(new Date()).format("YYYY_MM_DD HH:mm:ss") ||
      moment(live_finish).format("YYYY_MM_DD HH:mm:ss") <
        moment(new Date()).format("YYYY_MM_DD HH:mm:ss")
    ) {
      alert("예약된 방송 시간이 아닙니다.");
    } else {
      // if (/iPhone|iPad|iPod/i.test(userAgent)) {
      live_status();
      // } else {
      //   alert("송출 가능한 기기가 아닙니다.");
      // }
    }
  };

  const live_status = async () => {
    try {
      const res = await api.get(url.Communication_url.live_status);
      if (!res.data.isLive) {
        setLivestart("start");
        modify_live_status("시작");
      }
    } catch (err) {
      console.log("실패: ", err);
    }
  };

  const modify_live_status = async (item: string) => {
    await api.post(url.Communication_url.motify_live_status, {
      seq: seq,
      status: item,
    });
  };

  const Live_End = () => {
    setLivestart("end");
    modify_live_status("종료");
  };

  const chatRef = useRef<ChatComponentRef>(null); // Ref 타입을 명시

  const handleSendMessage = () => {
    if (chatRef.current) {
      if (mesage.length <= 100) {
        chatRef.current.sendMessage(); // ChatComponent의 sendMessage 호출

        set_Mesage("");
      } else {
        alert("입력 가능한 글자 수는 최대 100자입니다.");
      }
    }
  };

  // 소켓
  const SOCKET_SERVER_URL = "https://fanbird.live/live";
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (seq === "undefined") {
      alert("방송정보가 없습니다.");
      Navigate("/", { replace: true });
    }
    if (live_info) {
      seq !== "undefined" && is_visable_product();

      // 소켓 연결을 초기화합니다.
      const newSocket = io(SOCKET_SERVER_URL, {
        path: "/socket.io", // nginx에서 location /live/로 프록시 중이므로 필요
        transports: ["websocket"], // polling을 비활성화하고 WebSocket만 사용
      });
      setSocket(newSocket);

      newSocket.on("connect", () => {
        newSocket.emit("join-channel", { channelId: live_info?.channel_name });
      });

      newSocket.on("Duration Time", (data: string) => {
        // console.log("Duration Time : ", data);
        set_Live_Time(data);
      });
      newSocket.on("Viewer Count", (data: string) => {
        // console.log("Viewer Count : ", data);
        set_Viewer_Count(Number(data));
      });
      newSocket.on("Stock", (data: props_data_type) => {
        // console.log("Stock : ", data);
        set_Data(data);
      });
      newSocket.on("Stock Over", (data: props_data_type) => {
        // console.log("Stock Over: ", data);
        set_Data(data);
      });
      // 컴포넌트가 언마운트될 때 소켓 연결을 정리합니다.
      return () => {
        newSocket.disconnect();
      };
    }
  }, [live_info]);

  const is_visable_product = () => {
    axios
      .get(url.Communication_url.is_visable_product, {
        params: { live_seq: seq },
      })
      .then(function (response) {
        response.data !== "상품없음" && set_Data(response.data);
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };

  return (
    <Container translate="no">
      <Box>
        <Streaming_Box>
          <AdminLive
            livestart={livestart}
            selectedVideo_props={selectedVideo}
            selectedAudio_props={selectedAudio}
            live_info={live_info}
          />
          <Title_Box>
            <Title>{live_info?.live_title}</Title>
            {/* <Exit_Btn
              onClick={go_back}
              src={require("../../../Image/ic_x_white.png")}
            /> */}
          </Title_Box>
          <Status_Box>
            <RowView2>
              <Icon src={require("../../../Image/ic_live_red.png")} />
              <Time_Box>
                <Shadow_Icon
                  src={require("../../../Image/ic_time_white.png")}
                />
                &nbsp;{live_time}
              </Time_Box>
              <Viewer_Count_Box>
                <Shadow_Icon
                  src={require("../../../Image/ic_viewer_white.png")}
                />
                &nbsp;{viewer_count}
              </Viewer_Count_Box>
            </RowView2>
            <Start_Btn
              as="button"
              disabled={selectedAudio === "" || selectedVideo === ""}
              $state={livestart}
              $select_cam={selectedVideo}
              $select_mic={selectedAudio}
              onClick={() => {
                livestart === "end" ? Live_Start() : Live_End();
              }}
            >
              {livestart === "end" ? "라이브 시작" : "라이브 종료"}
            </Start_Btn>
          </Status_Box>

          {livestart === "end" && (
            <Device_Select_Box>
              <div>
                <Icon src={icon_question_circle_gray} />
                촬영 장치 선택
              </div>
              <select
                id="video-devices"
                value={selectedVideo}
                onChange={(e) => setSelectedVideo(e.target.value)} // 상태 업데이트
                disabled={videoDevices.length === 0}
              >
                <option value="" disabled>
                  카메라 선택
                </option>
                {videoDevices.map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Camera ${device.deviceId}`}
                  </option>
                ))}
              </select>
              <div id="audio-devices">
                <Icon src={icon_question_circle_gray} />
                녹음 장치 선택
              </div>
              <select
                value={selectedAudio}
                onChange={(e) => setSelectedAudio(e.target.value)} // 상태 업데이트
                disabled={audioDevices.length === 0}
              >
                <option value="" disabled>
                  마이크 선택
                </option>
                {audioDevices.map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Microphone ${device.deviceId}`}
                  </option>
                ))}
              </select>
            </Device_Select_Box>
          )}

          <Bottom_Box>
            <Bottom_Row>
              <Item_Chat_Box>
                <Chat_Box>
                  <ChatComponent
                    ref={chatRef}
                    mesage={mesage}
                    all_visible={true}
                    live_info={live_info!}
                  />
                </Chat_Box>
                {data && data.product_status === "판매노출" && (
                  <Item_Box>
                    <State
                      as="button"
                      disabled={data.current_cnt === 0}
                      $count={data.current_cnt}
                    >
                      <div>판매</div>
                      <div>상품</div>
                    </State>
                    <Item_Data_Box>
                      <div>
                        {data.name.length > 12
                          ? `${data.name.slice(0, 12)}...`
                          : data.name}
                      </div>
                      <RowView style={{ color: "#EA2922", width: "100%" }}>
                        <div>{amountFormat(data.price)}원</div>
                        {data.product_num !== null &&
                          data.product_num !== undefined && (
                            <div
                              style={{ color: "#C6C6C6", fontSize: 14 }}
                              translate="no"
                            >
                              No.{data.product_num}
                            </div>
                          )}
                      </RowView>
                    </Item_Data_Box>
                  </Item_Box>
                )}
              </Item_Chat_Box>
            </Bottom_Row>
            {/* <Chat_Insert_Box>
              <Chat_Insert>
                <Insert_Text
                  value={mesage}
                  placeholder="메시지를 입력해주세요."
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    set_Mesage(e.target.value)
                  }
                  onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter") {
                      handleSendMessage();
                    }
                  }}
                />
                <Send_Icon
                  src={require("../../../Image/ic_send_white.png")}
                  onClick={handleSendMessage}
                />
              </Chat_Insert>
            </Chat_Insert_Box> */}
          </Bottom_Box>
        </Streaming_Box>
      </Box>
    </Container>
  );
};

export default Live_Manage;

const Container = styled(CenterView)`
  width: 100%;
  min-height: 100vh;
  font-family: var(--font-Pretendard-Regular);
  background-color: #2d2d2d;
  color: #ffffff;
  display: flex;
  align-items: flex-start;
`;
const Box = styled.div`
  background-color: black;
  background-size: contain;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;
const Streaming_Box = styled.div`
  width: 100%;
  height: 100%;
  max-height: 1080px;
  min-height: 100vh;
  /* background-color: #de9c9c; */
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const Title_Box = styled.div`
  margin-top: 40px;
  width: 100%;
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1;
  align-items: center;
`;
const Title = styled.div`
  font-family: var(--font-Pretendard-Bold);
  font-size: 24px;
  margin-left: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
`;
const Exit_Btn = styled(Icon)`
  margin-right: 30px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  &:active {
    opacity: 0.5; // 클릭 시 opacity 변화
  }
`;
const Start_Btn = styled.div<Live_Start_Props>`
  border-width: 0px;
  background: ${(props) =>
    props.$select_cam === "" || props.$select_mic === ""
      ? "#f8f8f8"
      : props.$state === "end"
      ? "linear-gradient(135deg, #7955f0, #3209b9)"
      : "black"};

  color: ${(props) =>
    props.$select_cam === "" || props.$select_mic === "" ? "#C6C6C6" : "white"};
  border-radius: 8px;
  padding: 14px 16px;
  font-family: var(--font-Pretendard-SemiBold);
  font-size: 16px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;
const Status_Box = styled.div`
  z-index: 1;
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  box-sizing: border-box;
`;
const Time_Box = styled.div`
  margin-left: 8px;
  display: flex;
  font-family: var(--font-Pretendard-SemiBold);
  color: white;
  align-items: center;
  font-size: 16;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
`;
const Viewer_Count_Box = styled.div`
  margin-left: 16px;
  display: flex;
  font-family: var(--font-Pretendard-SemiBold);
  color: white;
  align-items: center;
  font-size: 16;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
`;
const Shadow_Icon = styled(Icon)`
  filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5)); /* 그림자 적용 */
`;
const Device_Select_Box = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0px 15px;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  color: #2d2d2d;
  font-family: var(--font-Pretendard-SemiBold);

  select {
    height: 46px;
    width: 100%;
    border-radius: 8px;
    border-width: 1px;
    border-style: solid;
    border-color: #f0f0f0;
    padding: 0px 15px;
    color: #8e8e8e;
    /* 기본 화살표 제거 */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    /* 커스텀 화살표 추가 */
    background-image: url(${icon_down_black});
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 20px;
  }
  #audio-devices {
    margin-top: 15px;
  }

  div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
`;
const Bottom_Box = styled.div`
  display: flex;
  width: 100%;
  /* background-color: #a9a9a9; */
  height: 430px;
  margin-top: auto;
  flex-direction: column;
  position: relative;
  padding: 15px 15px 30px 15px;
  box-sizing: border-box;
  z-index: 1;
`;
const Chat_Insert_Box = styled.div`
  align-self: flex-end;
  height: 50px;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`;
const Chat_Insert = styled.div`
  width: 100%;
  height: 48px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0px 25px;
  border-width: 1px;
  border-style: solid;
  border-color: white;
  border-radius: 100px;
  align-items: center;
  display: flex;
  position: relative;
  box-sizing: border-box;
  justify-content: space-between;
`;
const Bottom_Row = styled(RowView)`
  flex: 1;
  margin-bottom: 15px;
`;
const Item_Chat_Box = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
  flex-direction: column;
  margin-right: 18px;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  box-sizing: border-box;
`;
const Chat_Box = styled.div`
  width: 100%;
  max-width: 100%;
  height: 230px;
  max-height: 230px;
  flex: 1;
  display: flex;
  position: relative;
  box-sizing: border-box;
`;
const Item_Box = styled.div`
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
`;
const Item_Data_Box = styled.div`
  background-color: white;
  color: black;
  flex: 9;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  justify-content: center;
  padding: 0px 18px;
  height: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;
const State = styled.div<BuyBtnProps>`
  background-image: ${(props) =>
    props.$count === 0
      ? "linear-gradient(to bottom right, #F8F8F8,#F8F8F8)"
      : "linear-gradient(135deg, #7955f0, #3209b9)"};
  color: ${(props) => (props.$count === 0 ? "#8E8E8E" : "white")};
  flex: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-Pretendard-Bold);
  border-width: 0px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
  &:active {
    opacity: 0.5;
    &:disabled {
      opacity: 1;
    }
  }
`;
const Send_Icon = styled(Shadow_Icon)`
  justify-self: flex-end;
  cursor: pointer;
  &:active {
    opacity: 0.5;
  }
`;
const Insert_Text = styled.input`
  outline: none;
  border: none;
  width: 100%;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
  color: white;
  &::placeholder {
    color: white;
  }
`;
